export default __webpack_public_path__ + "static/media/9.b284f568.svg";